// extracted by mini-css-extract-plugin
module.exports = {"wrap":"LeaderboardBadge_wrap__12w5-","icon":"LeaderboardBadge_icon__30I30","label":"LeaderboardBadge_label__3LbAj"};